<template>
  <div :class="$vuetify.breakpoint.smAndDown ? 'd-flex' : ''">
    <!-- filtro de rubro y categoria -->
    <!-- si ya hay algo filtrado por rubro o categoria no dejo volver a filtrar por eso -->
    <div
      v-if="filtro.filter(fto => fto.type == 'rubro' || fto.type == 'categoria').length == 0"
      class="pb-4"
      :style="`width: ${$vuetify.breakpoint.mdAndUp ? 100 : 50}%;`"
    >
      <div
        v-for="(rubro, index) in rubros"
        :key="index"
        class="px-4"
      >
        <div
          class="d-flex align-center font-weight-medium body-2"
          :style="`font-size: ${$vuetify.breakpoint.lgAndUp ? 14 : 13}px !important; cursor: default;`"
        >
          <v-icon
            small
            left
            @click="$emit('filtrar', 'rubro', rubro)"
          >
            {{
              filtro.find(fto => fto.type == 'rubro' && fto.value == rubro) ? 'fas fa-check-square' : 'far fa-square'
            }}
          </v-icon>
          <span
            style="cursor: pointer;"
            @click="$emit('filtrar', 'rubro', rubro)"
          >
            {{ rubro }}
          </span>
        </div>
        <div v-if="categorias.filter(ca => ca.rubro == rubro).length > 1" class="pt-1 pb-2">
          <div
            v-for="(item, index) in categorias.filter(ca => ca.rubro == rubro)"
            :key="index"
            class="d-flex align-center ml-3 body-2"
            :style="`font-size: ${$vuetify.breakpoint.lgAndUp ? 13 : 12}px !important; cursor: default;`"
          >
            <v-icon
              :x-small="!$vuetify.breakpoint.lgAndUp"
              :small="$vuetify.breakpoint.lgAndUp"
              left
              @click="$emit('filtrar', 'categoria', item.categoria)"
            >
              {{
                filtro.find(fto => fto.type == 'categoria' && fto.value == item.categoria) ? 'fas fa-check-square' : 'far fa-square'
              }}
            </v-icon>
            <span
              style="cursor: pointer;"
              @click="$emit('filtrar', 'categoria', item.categoria)"
            >
              {{ item.categoria }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- filtro de marca -->
    <!-- si ya hay algo filtrado por marca no dejo volver a filtrar por eso -->
    <div
      v-if="filtro.filter(fto => fto.type == 'marca_nombre').length == 0"
      class="px-4 pb-4"
      :style="`width: ${$vuetify.breakpoint.mdAndUp ? 100 : 50}%; cursor: default;`"
    >
      <div class="pb-1">
        Marca
      </div>
      <div
        v-for="(marca, index) in marcas.slice(0, mas_marcas ? marcas.length : 10)"
        :key="index"
        class="d-flex align-center body-2 ml-3"
        :style="`font-size: ${$vuetify.breakpoint.lgAndUp ? 14 : 13}px !important;`"
      >
        <v-icon
          small
          left
          @click="$emit('filtrar', 'marca_nombre', marca)"
        >
          {{
            filtro.find(fto => fto.type == 'marca_nombre' && fto.value == marca) ? 'fas fa-check-square' : 'far fa-square'
          }}
        </v-icon>
        <span
          style="cursor: pointer;"
          @click="$emit('filtrar', 'marca_nombre', marca)"
        >
          {{ marca }}
        </span>
      </div>
      <a
        v-if="!mas_marcas && marcas.length > 10"
        style="font-size: 13px;"
        @click="mas_marcas = true"
      >
        Mostrar más...
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    p_mas_marcas: Boolean,
    p_marcas: Array,
    p_rubros: Array,
    p_categorias: Array
  },
  computed: {
    filtro: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    mas_marcas: {
      get () {
        return this.p_mas_marcas
      },
      set (value) {
        this.$emit('update:p_mas_marcas', value)
      }
    },
    marcas: {
      get () {
        return this.p_marcas
      },
      set (value) {
        this.$emit('update:p_marcas', value)
      }
    },
    rubros: {
      get () {
        return this.p_rubros
      },
      set (value) {
        this.$emit('update:p_rubros', value)
      }
    },
    categorias: {
      get () {
        return this.p_categorias
      },
      set (value) {
        this.$emit('update:p_categorias', value)
      }
    }
  }
}
</script>